import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

const useDeleteCreditTransaction = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation(
    (id: number) => {
      return fetch(`${API}/api/semeadora/credit-transactions/${id}/`, {
        method: "DELETE",
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["credit-transactions"]);
        queryClient.invalidateQueries(["urban-partners"]);
      },
    },
  );
};

export default useDeleteCreditTransaction;
